import React, { forwardRef, useRef } from 'react';
import IMask from 'imask';
import { IMaskInput as IMaskInputBase } from 'react-imask';
const IMaskInput = IMaskInputBase as any;
import moment from 'moment';
import { clsx } from 'clsx';
import { InputInfoToolTip } from 'src/components/Input/InputInfoToolTip';
import { uuid } from 'src/utils/uuid';

const momentFormat = 'MM/DD/YYYY';

export const MaskedDateInput = forwardRef<any, any>(
  ({ label, error = null, infoTooltip = false, ...props }, ref) => {
    ref = ref || useRef(null);
    const id = label ? `${label.replace(/\s+/g, '-').toLowerCase()}-${uuid()}` : uuid();

    return (
      <div>
        {label ? (
          <label htmlFor={`${id}`} className={clsx('flex flex-row gap-[5px] items-center')}>
            <span>{label}</span>
            {infoTooltip && <InputInfoToolTip infoToolTip={infoTooltip} />}
          </label>
        ) : null}
        <div className={'relative'}>
          <IMaskInput
            ref={ref as any}
            id={id}
            className={clsx(
              'py-2.5 px-3.5 font-medium text-sm text-ebony',
              Boolean(error) && '!border-error text-error',
            )}
            mask={Date}
            pattern={momentFormat}
            lazy={false}
            min={new Date(1970, 0, 1)}
            max={new Date(2999, 0, 1)}
            onAccept={props.onChange}
            format={(date) => moment(date).format(momentFormat)}
            parse={(str) => moment(str, momentFormat)}
            placeholder={'mm/dd/yyyy'}
            blocks={{
              YYYY: {
                mask: IMask.MaskedRange,
                from: 1970,
                placeholderChar: 'Y',
                to: 2999,
              },
              MM: {
                mask: IMask.MaskedRange,
                placeholderChar: 'M',
                from: 1,
                to: 12,
              },
              DD: {
                mask: IMask.MaskedRange,
                placeholderChar: 'D',
                from: 1,
                to: 31,
              },
            }}
            {...props}
          />
          {Boolean(error?.message) && (
            <div
              className={
                'absolute right-1 top-1 bottom-1 px-3.5 font-semibold text-error text-sm bg-error_bg rounded-sm-5 flex items-center justify-center z-10'
              }
            >
              <p>{error.message}</p>
            </div>
          )}
        </div>
      </div>
    );
  },
);
